import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=01831b20&scoped=true&"
import script from "./Sandbox.vue?vue&type=script&lang=ts&"
export * from "./Sandbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01831b20",
  null
  
)

export default component.exports